const es = {
  nav: {
    home: 'Inicio',
    about: 'Empresa',
    services: 'Servicios',
    projects: 'Proyectos',
    trust: 'Cumplimiento',
    contact: 'Contacto',
    partnerships: 'Colaboraciones',
    cta: 'Solicitar llamada de colaboración',
    menu: 'Menú',
  },
  hero: {
    badge: 'B2B · Mercados DACH · Disponible en la UE',
    headline: 'Capacidad de instalación solar que puede planificar.',
    subheadline:
      'Subcontratista español de instalaciones para EPCs, empresas solares y operadores de energía en toda Europa. Dos equipos estructurados. Capacidad planificable. Documentación completa.',
    cta_primary: 'Solicitar llamada de colaboración',
    cta_secondary: 'Ver nuestros servicios',
    image_caption: 'Ejecución en obra · HSE prioritario · Documentación lista',
  },
  metrics: {
    title: 'Capacidad operativa',
    subtitle: 'Cifras clave para la planificación de proyectos y asignación de capacidad.',
    workers: { label: 'Operarios de instalación', value: '6' },
    teams: { label: 'Equipos independientes', value: '2' },
    capacity: { label: 'Capacidad diaria', value: '~2' },
    capacity_unit: 'instalaciones/día',
    experience: { label: 'Años en operación', value: '5+' },
  },
  services: {
    title: 'Servicios',
    subtitle: 'Servicios de instalación completos para operadores solares, EPCs y empresas de energía.',
    pv: {
      title: 'Instalaciones FV Residenciales',
      description:
        'Instalación solar residencial completa desde la evaluación del emplazamiento hasta la puesta en marcha. Coordinación de equipos, montaje, cableado, pruebas y documentación as-built incluidos.',
      badges: ['B2B', 'SLA listo', 'Disponible en la UE'],
      features: [
        'Planificación y coordinación de equipos',
        'Montaje y cableado en obra',
        'Puesta en marcha y pruebas',
        'Documentación as-built',
      ],
    },
    ev: {
      title: 'Instalaciones de Cargadores VE',
      description:
        'Instalación profesional de infraestructura de carga de vehículos eléctricos con coordinación completa, pruebas y documentación de entrega. Preparado para programas de despliegue en múltiples ubicaciones.',
      badges: ['B2B', 'Múltiples ubicaciones', 'Listo para rollout'],
      features: [
        'Coordinación con electricistas',
        'Instalación de infraestructura',
        'Pruebas y puesta en marcha',
        'Informes técnicos de entrega',
      ],
    },
    repairs: {
      title: 'Reparaciones y Respuesta a Incidencias',
      description:
        'Respuesta rápida en obra ante fallos de instalación y problemas del sistema. Triaje estructurado, resolución e informe fotográfico completo para sus registros.',
      badges: ['SLA listo', 'Respuesta rápida', 'Documentado'],
      features: [
        'Diagnóstico prioritario',
        'Reparación en obra',
        'Documentación fotográfica',
        'Informes escritos de incidencias',
      ],
    },
    learn_more: 'Ver detalles completos del servicio',
  },
  why: {
    title: 'Por qué trabajar con nosotros',
    subtitle:
      'Diseñado para EPCs y operadores solares que necesitan un socio de instalación fiable.',
    principles: [
      {
        title: 'Dos equipos independientes',
        desc: 'Planificación de instalaciones en paralelo. Dos equipos completamente equipados que operan de forma independiente en diferentes emplazamientos.',
      },
      {
        title: 'Documentación estructurada',
        desc: 'Cada instalación incluye actas de puesta en marcha, fotografías as-built, listas de verificación e informes de entrega, listos para su flujo de trabajo.',
      },
      {
        title: 'Disponible en la UE y móvil',
        desc: 'Con sede en la Comunidad Valenciana y experiencia contrastada en Madrid y Barcelona. Disponible para proyectos en Alemania, Austria, Suiza y la UE.',
      },
      {
        title: 'Trayectoria contrastada',
        desc: 'Experiencia como subcontratista con 1komma5°, Verne, EDP y Holaluz, empresas con altos estándares de calidad, cumplimiento y documentación.',
      },
    ],
    accordion: [
      {
        title: 'Cumplimiento HSE',
        content:
          'Todos los equipos operan bajo estrictos protocolos de seguridad y salud laboral. EPIs, protección contra caídas y documentación de seguridad en obra son procedimientos estándar en cada trabajo.',
      },
      {
        title: 'Estándares de documentación',
        content:
          'Entregamos documentación as-built completa: fotografías de instalación, informes de puesta en marcha, esquemas eléctricos (cuando corresponda) y listas de verificación firmadas.',
      },
      {
        title: 'Equipamiento y herramientas',
        content:
          'Los equipos llegan completamente equipados con herramientas de instalación profesionales, equipos de seguridad e instrumentos de prueba. Sin dependencia del equipamiento del cliente.',
      },
    ],
  },
  partners: {
    title: 'Clientes y socios',
    subtitle: 'Hemos trabajado como subcontratistas de instalación para:',
  },
  gallery_preview: {
    title: 'Proyectos seleccionados',
    subtitle: 'Una selección de trabajos de instalación residencial y comercial recientes.',
    view_all: 'Ver todos los proyectos',
  },
  cta_section: {
    title: '¿Listo para ampliar su capacidad de instalación?',
    subtitle:
      'Hable con nosotros sobre sus próximos proyectos en España, Alemania, Austria o Suiza. Normalmente podemos movilizarnos en una semana.',
    cta: 'Solicitar llamada de colaboración',
    secondary: 'o escríbanos a info@energiesse.com',
  },
  about: {
    headline: 'Un socio de instalación fiable, diseñado para operaciones B2B.',
    intro:
      'ENERGIESSE SL es un subcontratista español de instalaciones solares especializado en sistemas FV residenciales, instalaciones de cargadores de vehículos eléctricos y respuesta rápida a incidencias. Trabajamos exclusivamente con empresas solares, EPCs y operadores de energía.',
    team_title: 'Estructura del equipo',
    team_subtitle:
      'Dos equipos de instalación independientes, capaces de operar simultáneamente en diferentes emplazamientos.',
    team_1: {
      title: 'Equipo de Instalación A',
      role: 'Instalaciones FV nuevas',
      desc: 'Equipo especializado en sistemas FV residenciales nuevos. Ciclo completo: evaluación, montaje, cableado, puesta en marcha y documentación.',
    },
    team_2: {
      title: 'Equipo de Instalación B',
      role: 'Cargadores VE e incidencias',
      desc: 'Equipo especializado en instalaciones de cargadores de VE y respuesta rápida a incidencias. Disponible para despliegue paralelo junto al Equipo A.',
    },
    capacity_title: 'Capacidad operativa',
    capacity_items: [
      { label: 'Total de operarios', value: '6 especialistas formados' },
      { label: 'Estructura de equipos', value: '2 equipos independientes de 3' },
      { label: 'Producción diaria', value: '~2 instalaciones residenciales/día' },
      { label: 'Escalabilidad', value: 'Equipos desplegables en regiones distintas' },
    ],
    geography_title: 'Cobertura geográfica',
    geography_primary: 'Región principal',
    geography_primary_value: 'Comunidad Valenciana, España',
    geography_secondary: 'Cobertura establecida',
    geography_secondary_value: 'Madrid, Barcelona',
    geography_international: 'Disponibilidad internacional',
    geography_international_value: 'Alemania, Austria, Suiza y resto de la UE',
    compliance_title: 'Posicionamiento profesional',
    compliance_desc:
      'ENERGIESSE SL opera exclusivamente como subcontratista de instalaciones B2B. No somos una empresa orientada al consumidor final. Nuestros estándares de documentación, procesos y condiciones comerciales están diseñados para operadores profesionales con programas de instalación en múltiples ubicaciones.',
    values_title: 'Nuestros principios operativos',
    values: [
      { title: 'Fiabilidad', desc: 'Cumplimos los calendarios acordados. Si las circunstancias cambian, comunicamos con antelación.' },
      { title: 'Documentación', desc: 'Cada proyecto deja un registro documental completo. Sin excepciones.' },
      { title: 'Seguridad', desc: 'El cumplimiento HSE no es opcional. Es nuestra base en cada obra.' },
      { title: 'Claridad', desc: 'Precios claros, plazos claros, comunicación clara. Sin sorpresas.' },
    ],
  },
  services_page: {
    headline: 'Servicios de instalación para operadores profesionales.',
    subtitle: 'Tres áreas de servicio principales, diseñadas para contratos de subcontratación B2B. Listos para SLA, documentados y escalables.',
    pv: {
      headline: 'Instalaciones FV Residenciales',
      intro: 'Nuestro servicio principal. Instalación fotovoltaica residencial completa para EPCs y operadores solares con programas de rollout en España y Europa.',
      scope: 'Alcance del servicio',
      scope_items: [
        'Evaluación del emplazamiento y documentación previa',
        'Montaje de paneles y preparación de la estructura',
        'Cableado DC y configuración de strings',
        'Instalación del inversor y conexión AC',
        'Puesta en marcha del sistema y verificación de rendimiento',
        'Documentación as-built y paquete de entrega al cliente',
      ],
      b2b_note: 'Operamos como socio de instalación white-label. La documentación de entrega puede adaptarse a su flujo de trabajo.',
    },
    ev: {
      headline: 'Instalaciones de Cargadores VE',
      intro: 'Instalación profesional de cargadores de vehículos eléctricos para propiedades residenciales y comerciales. Preparado para programas de rollout en múltiples ubicaciones.',
      scope: 'Alcance del servicio',
      scope_items: [
        'Inspección del emplazamiento y evaluación de infraestructura',
        'Instalación de la unidad EVSE y fijación en pared',
        'Tendido de cables y conexión eléctrica',
        'Coordinación con electricistas autorizados',
        'Pruebas, verificación de carga y puesta en marcha',
        'Documentación de entrega completa',
      ],
      b2b_note: 'Adecuado para operadores con compromisos de volumen recurrente. Contratos marco disponibles.',
    },
    repairs: {
      headline: 'Reparaciones y Respuesta a Incidencias',
      intro: 'Servicio de diagnóstico y reparación en obra para sistemas FV y de carga de VE. Respuesta estructurada para EPCs que gestionan reclamaciones de garantía o bajo rendimiento.',
      scope: 'Alcance del servicio',
      scope_items: [
        'Reserva de respuesta prioritaria (normalmente en 48-72 horas)',
        'Diagnóstico en obra e identificación de causa raíz',
        'Reparación o sustitución de componentes',
        'Verificación del rendimiento tras la reparación',
        'Informe fotográfico y escrito',
        'Protocolo de escalada para averías complejas',
      ],
      b2b_note: 'Los informes de incidencias están estructurados para su inclusión directa en sus sistemas de comunicación con el cliente y seguimiento de garantías.',
    },
    common: {
      b2b_badge: 'Solo B2B',
      geographic_note: 'Cobertura del servicio: España (principal) · Alemania, Austria, Suiza, UE (bajo acuerdo)',
      contact_cta: 'Solicitar discusión de alcance',
    },
  },
  projects_page: {
    headline: 'Cartera de instalaciones',
    subtitle: 'Proyectos residenciales y comerciales seleccionados. Todos los proyectos realizados como subcontratista B2B.',
    filter_all: 'Todos',
    filter_pv: 'Instalaciones FV',
    filter_ev: 'Cargadores VE',
    filter_repairs: 'Reparaciones',
    before: 'Antes',
    after: 'Después',
    video_placeholder: 'Vídeo de instalación — disponible bajo petición',
    projects: [
      { id: 'p1', title: 'FV Residencial — Valencia', type: 'pv', capacity: '6,5 kWp', panels: '13 paneles', location: 'Comunidad Valenciana', year: '2024', client: 'Socio EPC (confidencial)', before_img: 'https://images.unsplash.com/photo-1605980776566-0486c3ac7617?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&q=80' },
      { id: 'p2', title: 'FV Residencial — Madrid', type: 'pv', capacity: '8,2 kWp', panels: '16 paneles', location: 'Madrid', year: '2024', client: 'Socio EPC (confidencial)', before_img: 'https://images.unsplash.com/photo-1558449907-29a1048b85b9?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=800&q=80' },
      { id: 'p3', title: 'FV Multiviv. — Barcelona', type: 'pv', capacity: '24 kWp', panels: '48 paneles', location: 'Barcelona', year: '2023', client: 'Operador solar (confidencial)', before_img: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=800&q=80' },
      { id: 'p4', title: 'Cargador VE — Valencia', type: 'ev', capacity: '11 kW', panels: '1 unidad', location: 'Comunidad Valenciana', year: '2024', client: 'Operador energético (confidencial)', before_img: 'https://images.unsplash.com/photo-1593941707882-a5bba13c2e09?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80' },
      { id: 'p5', title: 'Respuesta incidencia — Madrid', type: 'repairs', capacity: '5,5 kWp', panels: '11 paneles', location: 'Madrid', year: '2023', client: 'Socio EPC (confidencial)', before_img: 'https://images.unsplash.com/photo-1595437193398-f24279553f4f?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1564151436289-8fc3f8ea6326?w=800&q=80' },
      { id: 'p6', title: 'FV Residencial grande — Valencia', type: 'pv', capacity: '12 kWp', panels: '24 paneles', location: 'Comunidad Valenciana', year: '2024', client: 'Operador solar (confidencial)', before_img: 'https://images.unsplash.com/photo-1548348384-a1069e9d4179?w=800&q=80', after_img: 'https://images.unsplash.com/photo-1552197892-f2ad2f75e7c8?w=800&q=80' },
    ],
  },
  trust: {
    headline: 'Cumplimiento y Acreditaciones',
    subtitle: 'Situación legal, cobertura de seguros y certificaciones profesionales, disponibles para due diligence de socios.',
    legal_title: 'Entidad legal',
    legal_fields: [
      { label: 'Nombre de la empresa', value: 'ENERGIESSE SL' },
      { label: 'Forma jurídica', value: 'Sociedad Limitada (SL)' },
      { label: 'CIF / NIF', value: 'Disponible bajo solicitud' },
      { label: 'Domicilio social', value: 'Comunidad Valenciana, España' },
      { label: 'Dominio web', value: 'energiesse.com' },
      { label: 'Contacto principal', value: 'info@energiesse.com' },
    ],
    insurance_title: 'Cobertura de seguros',
    insurance_items: [
      { label: 'Seguro de responsabilidad civil', status: 'Activo', detail: 'Cobertura por daños a terceros durante operaciones en obra' },
      { label: 'Responsabilidad profesional', status: 'Activo', detail: 'Cobertura por defectos de instalación' },
      { label: 'Seguro de accidentes laborales', status: 'Activo', detail: 'Cobertura completa para todos los miembros del equipo' },
    ],
    cert_title: 'Certificaciones y formación',
    cert_items: [
      { label: 'Certificación de instalador fotovoltaico', status: 'Vigente', issuer: 'Autoridad española de energías renovables' },
      { label: 'Cualificación para instalación de cargadores VE', status: 'Vigente', issuer: 'Proveedor de formación acreditado' },
      { label: 'Instalación eléctrica de baja tensión', status: 'Vigente', issuer: 'Autoridad eléctrica española' },
      { label: 'Formación HSE / Seguridad laboral', status: 'Vigente', issuer: 'Autoridad de seguridad laboral' },
    ],
    safety_title: 'Estándares de seguridad',
    safety_desc:
      'Todos los equipos de instalación operan bajo estrictos protocolos HSE. La documentación de seguridad en obra, los planes de cumplimiento de EPIs y los procedimientos de protección contra caídas se aplican en todos los proyectos, independientemente del tamaño o duración.',
    docs_title: 'Documentación entregable',
    docs_intro: 'Cada proyecto completado genera el siguiente paquete de documentación:',
    docs_items: [
      'Acta de puesta en marcha (firmada)',
      'Registro fotográfico as-built',
      'Esquema unifilar eléctrico (cuando corresponda)',
      'Lista de verificación de aceptación del cliente',
      'Informe de incidencia o desviación (cuando corresponda)',
    ],
    request_docs: 'Solicitar documentación de cumplimiento',
    request_docs_note: 'Certificados de seguro y documentos de acreditación disponibles bajo NDA o para socios precalificados.',
    active: 'Activo',
    current: 'Vigente',
  },
  contact: {
    headline: 'Solicitar llamada de colaboración',
    subtitle:
      'Cuéntenos sus necesidades de instalación. Respondemos a todas las consultas B2B en un día hábil.',
    email_label: 'Contacto directo',
    email_value: 'info@energiesse.com',
    response_note: 'Respuesta en 1 día hábil',
    form_title: 'Consulta de colaboración',
    form_company: 'Nombre de la empresa',
    form_company_placeholder: 'Nombre de su empresa',
    form_name: 'Persona de contacto',
    form_name_placeholder: 'Su nombre completo',
    form_email: 'Correo empresarial',
    form_email_placeholder: 'usted@empresa.com',
    form_phone: 'Teléfono (opcional)',
    form_phone_placeholder: '+34 ...',
    form_country: 'País',
    form_country_placeholder: 'Seleccione su país',
    form_project_type: 'Tipo de proyecto',
    form_project_type_placeholder: 'Seleccione tipo de proyecto',
    form_message: '¿Qué necesita de un socio instalador?',
    form_message_placeholder:
      'Describa su programa de instalación: volumen, regiones, plazos y requisitos específicos.',
    form_consent:
      'Confirmo que se trata de una consulta B2B y acepto ser contactado en relación con esta solicitud.',
    form_submit: 'Solicitar llamada de colaboración',
    form_success_title: 'Consulta recibida',
    form_success:
      'Gracias. Hemos recibido su consulta y le responderemos en un día hábil.',
    form_error:
      'Se produjo un problema al enviar su consulta. Inténtelo de nuevo o contáctenos directamente en info@energiesse.com.',
    project_types: [
      'Rollout de FV residencial',
      'Rollout de cargadores VE',
      'Programa de reparaciones y mantenimiento',
      'Mixto / por determinar',
    ],
    countries: [
      'Alemania',
      'Austria',
      'Suiza',
      'España',
      'Otro país de la UE',
    ],
    validation: {
      company_required: 'El nombre de la empresa es obligatorio',
      name_required: 'El nombre de la persona de contacto es obligatorio',
      email_required: 'El correo empresarial es obligatorio',
      email_invalid: 'Introduzca una dirección de correo válida',
      country_required: 'Seleccione su país',
      project_type_required: 'Seleccione un tipo de proyecto',
      message_required: 'Describa sus necesidades',
      consent_required: 'El consentimiento es obligatorio',
    },
  },
  partnerships: {
    headline: 'Colaborar con ENERGIESSE SL',
    subtitle:
      'Buscamos activamente acuerdos de subcontratación y colaboración con instaladores solares, EPCs y operadores de energía en Alemania, Austria y Suiza.',
    offer_title: 'Qué ofrecemos como socio subcontratista',
    offer_items: [
      {
        title: 'Capacidad de instalación dedicada',
        desc: 'Reserve capacidad de instalación para su cartera de proyectos. Dos equipos independientes para planificación paralela y ejecución en múltiples ubicaciones.',
      },
      {
        title: 'Documentación de entrega completa',
        desc: 'Cada proyecto incluye actas de puesta en marcha, fotos as-built y listas de verificación, listos para su flujo de entrega al cliente.',
      },
      {
        title: 'Movilidad y flexibilidad en la UE',
        desc: 'Con sede en España, disponibles en toda Europa. Movilización para proyectos en Alemania, Austria, Suiza y otros países de la UE con plazos cortos.',
      },
      {
        title: 'Fiabilidad contrastada con operadores del sector',
        desc: 'Experiencia con 1komma5°, Verne, EDP y Holaluz. Conocemos los estándares de calidad y documentación exigidos por los grandes operadores.',
      },
    ],
    process_title: 'Cómo funciona una colaboración',
    process_steps: [
      { step: '01', title: 'Llamada inicial', desc: 'Hablamos sobre su cartera de proyectos, necesidades de capacidad, regiones y plazos. Sin compromiso.' },
      { step: '02', title: 'Propuesta', desc: 'Presentamos una propuesta de capacidad y condiciones adaptada a su programa. Normalmente en 2 días hábiles.' },
      { step: '03', title: 'Acuerdo', desc: 'Formalizamos un contrato de subcontratación o contrato marco que cubre alcance, tarifas, documentación y SLAs.' },
      { step: '04', title: 'Primer despliegue', desc: 'Los equipos se movilizan para sus primeros proyectos. Documentación entregada en cada finalización. Revisión de rendimiento tras el piloto.' },
    ],
    requirements_title: 'Perfil de socio ideal',
    requirements_items: [
      'EPC solar o empresa instaladora activa en DACH o España',
      'Cartera de proyectos de 5+ instalaciones al mes o programa recurrente',
      'Necesita documentación fiable y entrega de instalaciones white-label',
      'Valora rapidez, consistencia y comunicación clara',
    ],
    cta_title: 'Iniciar la conversación',
    cta_subtitle: 'Comparta sus necesidades con nosotros. Respondemos en un día hábil.',
    cta: 'Solicitar llamada de colaboración',
    faq_title: 'Preguntas frecuentes',
    faqs: [
      {
        q: '¿Trabajan fuera de España?',
        a: 'Sí. Nuestras operaciones principales están en la Comunidad Valenciana, con experiencia establecida en Madrid y Barcelona. Estamos disponibles para proyectos internacionales en Alemania, Austria, Suiza y otros países de la UE.',
      },
      {
        q: '¿Pueden gestionar altos volúmenes de instalación?',
        a: 'Nuestra capacidad estándar es de aproximadamente 2 instalaciones residenciales al día con nuestros dos equipos. Para volúmenes mayores o programas urgentes, podemos discutir escalado de capacidad.',
      },
      {
        q: '¿Qué documentación entregan?',
        a: 'Cada instalación completada incluye: acta de puesta en marcha, fotos as-built, esquemas eléctricos (cuando corresponda) y lista de verificación firmada. Los informes pueden formatearse para su flujo de entrega.',
      },
      {
        q: '¿Operan como socio white-label?',
        a: 'Sí. Operamos como subcontratista silencioso cuando se requiere. La documentación, ropa de trabajo y comunicaciones pueden alinearse con los requisitos de su marca.',
      },
    ],
  },
  footer: {
    company: 'ENERGIESSE SL',
    domain: 'energiesse.com',
    email: 'info@energiesse.com',
    tagline: 'Subcontratista B2B de instalaciones solares · España · UE',
    legal: 'Aviso legal',
    privacy: 'Política de privacidad',
    rights: 'Todos los derechos reservados.',
    nav_title: 'Navegación',
    contact_title: 'Contacto',
    legal_title: 'Legal',
    address: 'Comunidad Valenciana, España',
  },
  language_changed: 'Idioma establecido en Español',
  common: {
    loading: 'Enviando...',
    back: 'Volver',
    read_more: 'Leer más',
    close: 'Cerrar',
  },
};

export default es;
